export default [
	{
		path: '/aipayment',
		name: 'AiPayment',
		component: () => import('../views/ai/aipayment'),
		meta: {
			title: '寻疗AI',
			keepAlive: false
		}
	},
	{
		path: '/ai/points/orders',
		name: 'AiPointsOrderList',
		component: () => import('../views/aiPoints/OrderList'),
		meta: {
			title: 'AI资源点订单',
			keepAlive: false
		}
	},
	{
		path: '/ai/points/usage',
		name: 'AiPointsUsageLog',
		component: () => import('../views/aiPoints/UsageLog'),
		meta: {
			title: '资源点消耗明细',
			keepAlive: false
		}
	},
	{
		path: '/ai/points/manage',
		name: 'AiPointsResourceManage',
		component: () => import('../views/aiPoints/ResourceManage'),
		meta: {
			title: '资源点管理',
			keepAlive: false
		}
	},
	{
		path: '/ai/points/recharge',
		name: 'AiPointsRecharge',
		component: () => import('../views/aiPoints/Recharge'),
		meta: {
			title: 'AI资源点充值',
			keepAlive: false
		}
	},
	{
		path: '/aidtl',
		name: 'AiDtl',
		component: () => import('../views/ai/aidtl'),
		meta: {
			title: 'AI充值',
			keepAlive: false
		}
	},
	{
		path: '/chat_ai/order_list',
		name: 'ChatAiOrderList',
		component: () => import('../views/chat_ai/order_list'),
		meta: {
			title: '问答AI',
			keepAlive: false
		}
	}
]
